"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const createReport_1 = require("../../__common/createReport");
const getElasticsearchQueryFromFilters_1 = require("../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const reportHelpers_1 = require("../../__common/reportHelpers");
const getAllStates_1 = require("./getAllStates");
function getAllUserContentReports(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const reportParmas = input.ReportParams;
        const sortParams = input.SortParams;
        const { filters, size = 1000 } = reportParmas;
        const projection = input.ReportProjection
            ? input.ReportProjection
            : { userContentMetricProjection: { excludes: ['user'] } };
        const { userContentMetricProjection: _source = {}, userProjection, contentProjection } = projection;
        const query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.stateFilters);
        // Fetching userContentMetrics for query
        if (Object.keys(query.bool).length > 0) {
            const { userContentMetrics, total } = yield getAllStates_1.getAllStates({
                query,
                projection: _source,
                sortParams,
                size
            });
            // Fetching user and content documents corresponding to matching results
            let users = [];
            let contents = [];
            // Fetching and setting related users like reviewer, assigner
            if (projection.relatedUserProjection) {
                yield reportHelpers_1.setRelatedUsers(rp, projection.relatedUserProjection, userContentMetrics);
            }
            // Fetching and setting related content, currently like nothing
            if (projection.relatedContentProjection) {
                yield reportHelpers_1.setRelatedContents(rp, projection.relatedContentProjection, userContentMetrics);
            }
            // Fetching and setting related states
            if (projection.relatedStateProjection) {
                yield reportHelpers_1.setRelatedStates(rp, projection.relatedStateProjection, userContentMetrics);
            }
            if (_source.custom && _source.custom.indexOf('user') >= 0) {
                users = yield reportHelpers_1.getUsers(rp, userProjection, userContentMetrics);
            }
            if (_source.custom && _source.custom.indexOf('content') >= 0) {
                contents = yield reportHelpers_1.getContents(rp, contentProjection, userContentMetrics);
            }
            return createReport_1.createUserContentReport({ userContentMetrics, users, contents, total });
        }
        return createReport_1.createUserContentReport({ userContentMetrics: [], users: [], contents: [], total: 0 });
    });
}
exports.getAllUserContentReports = getAllUserContentReports;
//# sourceMappingURL=index.js.map